


































import Vue from 'vue';

export default Vue.extend({
  name: 'Header',

  components: {},

  data: () => ({
    //
  }),

  computed: {
    baseBackendUrl(): string {
      return this.$store.state.baseBackendUrl;
    },
    logoutUrl(): string {
      return `${this.baseBackendUrl}accounts/logout/`;
    },
  },
});
